module.exports = __webpack_public_path__ + "img/person.46ea964f.png";